import { render, staticRenderFns } from "./AppPassword.vue?vue&type=template&id=5b38a3f9&scoped=true"
import script from "./AppPassword.vue?vue&type=script&lang=js"
export * from "./AppPassword.vue?vue&type=script&lang=js"
import style0 from "./AppPassword.vue?vue&type=style&index=0&id=5b38a3f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b38a3f9",
  null
  
)

export default component.exports